module.exports = __webpack_public_path__ + "img/群文件管理1.c58d6652.png";